export default function WorkerModalContainer({children, ...props}) {

    const hideX = props?.hideX || false;
    const maxWidth = props?.maxWidth || '775px';
    const overFlowHidden = !!props?.noOverFlow;

    

    return (
        <div className={`fixed top-0 left-0 right-0 bottom-0 w-full h-full bg-black/60 pt-[50px] text-center z-[100]`}>
            <div className={`relative w-full inline-block bg-white p-[24px] rounded-[8px] text-start`} style={{maxWidth:`${maxWidth}`}}>
                <div>
                    {children}
                </div>
            </div>
        </div>
    )
}